module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 003-8f0881e68db80f9a3f7ca2cf81b075f7.png";